import moment from "moment";
import {getPrizeNameByType} from "../helpers/functions";
import {useEffect, useState} from 'react'
import {maxUsernameLength} from '../helpers/config'

export const Row = (props) => {
    const shortenUsername = (name) => {
        const maxCensureLength = maxUsernameLength
        const matched = name.match(/\*/g) || []
        if (matched.length > maxCensureLength) {
            return `${name.slice(0,2)}${Array.from({length:maxCensureLength},()=>{return "*"}).join('')}${name.slice(name.length-2)}`
        } else {
            return name
        }
    }

    const {data} = props
    const [username, setUsername] = useState(shortenUsername(data.username))

    useEffect(() => {
        if (props.data.username === username) {
            return
        }
        setUsername(shortenUsername(props.data.username))
    }, [props.data])
    return (
        <>
            {props.type === 'Clasament' ?
                <div key={props.keyNr} className="card-row">
                    <div className="card-data">{data.nr}</div>
                    <div className="card-data" style={{justifyContent: "flex-start"}}>{username}</div>
                    <div className="card-data">{data.points}</div>
                    <div className="card-data">{data.prizeAmount.toLocaleString("ro-RO")} Lei</div>
                    <div className="card-data">
                        <div
                            className={data.evolution > 0 ? 'positive' : (data.evolution < 0 ? 'negative' : 'none')}>{data.evolution > 0 ? '▲' : (data.evolution < 0 ? '▼' : '')}</div>
                        &nbsp; {(data.evolution > 0 ? '+' : '') + data.evolution}
                    </div>
                </div>
                :
                <div key={props.keyNr} className="card-row">
                    <div className="card-data">{moment(data.prizeTime).format('DD.MM.YYYY')}</div>
                    <div className="card-data">{moment(data.prizeTime).format('HH:mm:ss')}</div>
                    <div className="card-data">{username}</div>
                    <div className="card-data">{data.prizeAmount.toLocaleString("ro-RO") + ' ' + getPrizeNameByType(data.prizeType)}</div>
                </div>
            }
        </>
    )
}
